// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { specificationsStyles } from "@turnerBlueprint/Overrides/Widgets/ProductDetails/ProductDetailsSpecifications";
import IconDocument from "@turnerBlueprint/XDL/Icons/IconDocument";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { createLinkIconStyles, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

specificationsStyles.specificationsAccordion = {
    headingLevel: 2,
    css: css`
        margin-top: 32px;
        @media print {
            button {
                display: block !important;
                width: 100%;
            }
        }
    `,
};

specificationsStyles.specificationsAttributesAccordionSection = {
    panelProps: {
        css: css`
            display: ${({ hidden }: any) => (hidden ? "none" : "grid")};
            row-gap: 8px;
            column-gap: 22px;
            grid-template-columns: 1fr 1fr;
            ${xScreen("lt", "sm")} {
                grid-template-columns: 1fr;
            }
            @media print {
                page-break-inside: avoid;
            }
        `,
    },
};

specificationsStyles.specificationsAccordionSection = {
    panelProps: {
        css: css`
            &,
            p {
                font-size: 14px;
                line-height: 22px;
                margin-bottom: 0;
            }

            ul {
                display: flex;
                flex-wrap: wrap;
                column-gap: 22px;
                margin: 0;
            }

            li {
                flex: 0 0 calc(50% - 11px);
                margin: 0 0 14px;

                ${xScreen("gte", 768)} {
                    &:nth-last-child(-n + 2) {
                        margin-bottom: 0;
                    }
                }
                ${xScreen("lt", "sm")} {
                    flex: 0 0 100%;
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
            @media print {
                page-break-inside: avoid;
            }
        `,
    },
};

specificationsStyles.attributeTypeWrapper = {
    css: css`
        display: flex;
        flex-wrap: nowrap;
        column-gap: 8px;
    `,
};
specificationsStyles.attributeTypeLabelText = {
    size: 12,
    lineHeight: "13px",
    weight: fontConfig.weight.bold,
    css: css`
        display: inline-flex;
        flex: 0 0 130px;
    `,
};

specificationsStyles.attributeTypeValuesText = {
    size: 12,
    lineHeight: "13px",
};

specificationsStyles.documentGridItem = {
    width: [12, 6, 6, 6, 6],
};

specificationsStyles.documentLink = {
    ...createLinkIconStyles(IconDocument, undefined, {
        size: 15,
        lineHeight: "18px",
        weight: fontConfig.weight.regular,
    }),
};
